(() => {
  'use strict';

  const shell = document.querySelector('[data-cinch-recovery]');
  if (!shell || shell.dataset.recoveryInitialized === 'true') return;
  shell.dataset.recoveryInitialized = 'true';

  const panel = shell.querySelector('[data-recovery-panel]');
  const launcher = shell.querySelector('[data-recovery-open]');
  const title = shell.querySelector('[data-recovery-title]');
  const description = shell.querySelector('[data-recovery-description]');
  const status = shell.querySelector('[data-recovery-status]');
  const reload = shell.querySelector('[data-recovery-reload]');
  if (!panel || !launcher || !title || !description || !status || !reload) return;

  const WAIT_MS = 60000;
  const MONITOR_MS = 600000;
  let timer;
  let lastTick = performance.now();
  let visibleTime = 0;
  let pendingTime = 0;
  let autoShown = false;
  let dismissed = false;
  let automaticPanel = false;
  let monitoring = false;

  // Read only the observed light-DOM loading layer. A canvas/shadow root can
  // already exist while setup has failed, so neither is a readiness signal.
  function hasVisibleAncestors(element) {
    if (!element || !element.isConnected) return false;
    for (let node = element; node; node = node.parentElement) {
      const style = window.getComputedStyle(node);
      if (node.hidden || style.display === 'none' ||
          style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function isVisible(element) {
    return hasVisibleAncestors(element) && element.getClientRects().length > 0;
  }

  function loadingState() {
    const root = document.getElementById('aircada-root');
    if (!root) return 'pending';
    if (!hasVisibleAncestors(root)) return 'unknown';
    const viewer = root.querySelector('air-viewer');
    if (!viewer) return 'pending';
    const layer = root.querySelector('#preload-layer');
    if (!layer) return 'unknown';
    if (isVisible(layer)) return 'pending';
    return isVisible(viewer) ? 'clear' : 'unknown';
  }

  function setMessage(automatic) {
    title.textContent = automatic ? 'Taking longer than expected?' : 'Need help with the customizer?';
    description.textContent = automatic
      ? 'Your build may still be loading. You can keep waiting or use the options below.'
      : 'You can keep waiting or check your cart.';
  }

  function openPanel(automatic) {
    automaticPanel = automatic;
    setMessage(automatic);
    panel.hidden = false;
    launcher.hidden = true;
    launcher.setAttribute('aria-expanded', 'true');
    if (automatic) {
      status.textContent = 'The customizer is taking longer than expected. Customizer help is available.';
    } else {
      panel.focus({ preventScroll: true });
    }
  }

  function closePanel(userDismissed) {
    const returnFocus = panel.contains(document.activeElement);
    if (userDismissed) dismissed = true;
    panel.hidden = true;
    launcher.hidden = false;
    launcher.setAttribute('aria-expanded', 'false');
    status.textContent = '';
    automaticPanel = false;
    if (returnFocus) launcher.focus({ preventScroll: true });
  }

  launcher.hidden = false;
  launcher.addEventListener('click', () => openPanel(false));
  shell.querySelectorAll('[data-recovery-close]').forEach(button => {
    button.addEventListener('click', () => closePanel(true));
  });
  shell.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) {
      event.preventDefault();
      closePanel(true);
    }
  });
  reload.addEventListener('click', () => {
    const confirmed = window.confirm('Reload the customizer? An unfinished design may be lost. If you already pressed Add to cart, check your cart before trying again.');
    if (confirmed) window.location.reload();
  });

  function stopMonitoring() {
    monitoring = false;
    window.clearTimeout(timer);
  }

  function tick() {
    if (!monitoring) return;
    const now = performance.now();
    // Do not count hidden-tab time or a long device/browser suspension.
    const elapsed = Math.max(0, Math.min(now - lastTick, 2000));
    lastTick = now;
    if (!document.hidden) {
      visibleTime += elapsed;
      const state = loadingState();
      pendingTime = state === 'pending' ? pendingTime + elapsed : 0;
      if (pendingTime >= WAIT_MS && !autoShown && !dismissed && panel.hidden && document.activeElement !== launcher) {
        autoShown = true;
        openPanel(true);
      }
      if (state === 'clear') {
        if (automaticPanel) {
          if (panel.contains(document.activeElement)) {
            setMessage(false);
            status.textContent = '';
            automaticPanel = false;
          } else {
            closePanel(false);
          }
        }
        // A hidden loading layer is not proof of purchase readiness. It only
        // ends this startup check; manual help stays available.
        if (visibleTime >= WAIT_MS) stopMonitoring();
      }
      if (visibleTime >= MONITOR_MS) stopMonitoring();
    }
    if (monitoring) timer = window.setTimeout(tick, 1000);
  }

  function startMonitoring() {
    stopMonitoring();
    if (shell.dataset.designMode === 'true') return;
    visibleTime = 0;
    pendingTime = 0;
    lastTick = performance.now();
    monitoring = true;
    timer = window.setTimeout(tick, 1000);
  }

  document.addEventListener('visibilitychange', () => { lastTick = performance.now(); });
  window.addEventListener('pagehide', stopMonitoring);
  window.addEventListener('pageshow', event => {
    if (event.persisted) startMonitoring();
  });
  startMonitoring();
  const staticHelp = shell.querySelector('[data-recovery-static]');
  if (staticHelp) staticHelp.hidden = true;
})();
